import React from "react";
import { motion } from "framer-motion";

export default function BookPage() {
  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)",
      padding: "clamp(2rem, 5vw, 3rem) clamp(1rem, 5vw, 2rem)",
      color: "white",
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      display: "flex",
      flexDirection: "column",
    }}>
      {/* CONTENIDO PRINCIPAL */}
      <div style={{
        flex: 1,
        padding: "0",
        maxWidth: "700px",
        margin: "0 auto",
        width: "100%",
        display: "flex",
        alignItems: "center",
      }}>
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          style={{
            textAlign: "center",
            width: "100%",
          }}
        >
          {/* ICONO DE MANTENIMIENTO */}
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
            style={{
              fontSize: "4rem",
              marginBottom: "2rem",
            }}
          >
            🔧
          </motion.div>

          {/* TÍTULO */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            style={{
              fontSize: "clamp(1.8rem, 5vw, 2.8rem)",
              marginBottom: "1rem",
              background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Estamos en Mantenimiento
          </motion.h2>

          {/* DESCRIPCIÓN */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            style={{
              fontSize: "1.1rem",
              opacity: 0.8,
              marginBottom: "2rem",
              lineHeight: "1.6",
            }}
          >
            Estamos realizando mejoras para ofrecerte una mejor experiencia. 
            Volveremos pronto con novedades.
          </motion.p>

          {/* DETALLES */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            style={{
              background: "rgba(30, 41, 59, 0.8)",
              padding: "2rem",
              borderRadius: "16px",
              border: "1px solid rgba(148, 163, 184, 0.3)",
              marginBottom: "2rem",
              backdropFilter: "blur(10px)",
            }}
          >
            <p style={{
              fontSize: "0.95rem",
              opacity: 0.6,
              marginBottom: "1rem",
            }}>
              Si necesitas contactar con nosotros:
            </p>

            <motion.a
              whileHover={{ scale: 1.05 }}
              href="https://wa.me/34675722551"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-block",
                fontSize: "1.1rem",
                fontWeight: "600",
                color: "#fbbf24",
                marginTop: "0.8rem",
                textDecoration: "none",
                padding: "0.8rem 1.5rem",
                borderRadius: "8px",
                border: "2px solid #fbbf24",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            >
              💬 WhatsApp: +34 675 722 551
            </motion.a>
          </motion.div>

          {/* ANIMACIÓN DE CARGA */}
          <motion.div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "0.5rem",
              marginBottom: "2rem",
            }}
          >
            {[0, 1, 2].map((i) => (
              <motion.div
                key={i}
                animate={{ y: [0, -10, 0] }}
                transition={{
                  duration: 0.6,
                  repeat: Infinity,
                  delay: i * 0.2,
                }}
                style={{
                  width: "12px",
                  height: "12px",
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #fbbf24, #f59e0b)",
                }}
              />
            ))}
          </motion.div>
        </motion.div>
      </div>

      {/* FOOTER */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        style={{
          marginTop: "3rem",
          paddingTop: "2rem",
          borderTop: "1px solid rgba(148, 163, 184, 0.2)",
          textAlign: "center",
        }}
      >
        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "2rem",
          marginBottom: "2rem",
        }}>
          {/* CONTACTO */}
          <div>
            <h3 style={{
              fontSize: "0.9rem",
              fontWeight: "600",
              marginBottom: "0.8rem",
              color: "#fbbf24",
              textTransform: "uppercase",
            }}>
              💬 Contacto
            </h3>
            <p style={{
              fontSize: "0.9rem",
              opacity: 0.7,
              margin: "0.4rem 0",
            }}>
              📱 +34 675 722 551
            </p>
            <a
              href="https://wa.me/34675722551"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "0.85rem",
                color: "#fbbf24",
                textDecoration: "none",
                cursor: "pointer",
              }}
            >
              Abrir WhatsApp →
            </a>
          </div>

          {/* UBICACIÓN */}
          <div>
            <h3 style={{
              fontSize: "0.9rem",
              fontWeight: "600",
              marginBottom: "0.8rem",
              color: "#fbbf24",
              textTransform: "uppercase",
            }}>
              📍 Ubicación
            </h3>
            <p style={{
              fontSize: "0.9rem",
              opacity: 0.7,
              margin: "0.4rem 0",
            }}>
              Calle Tucán, nº4
            </p>
            <p style={{
              fontSize: "0.9rem",
              opacity: 0.7,
              margin: "0.4rem 0",
            }}>
              41749 El Cuervo, Sevilla
            </p>
          </div>

          {/* REDES SOCIALES */}
          <div>
            <h3 style={{
              fontSize: "0.9rem",
              fontWeight: "600",
              marginBottom: "0.8rem",
              color: "#fbbf24",
              textTransform: "uppercase",
            }}>
              ✨ NewStyle23
            </h3>
            <p style={{
              fontSize: "0.9rem",
              opacity: 0.7,
              margin: "0.4rem 0",
            }}>
              Tu barberia de confianza
            </p>
          </div>
        </div>

        {/* COPYRIGHT */}
        <p style={{
          fontSize: "0.85rem",
          opacity: 0.5,
          margin: "1rem 0 0 0",
          paddingTop: "1rem",
          borderTop: "1px solid rgba(148, 163, 184, 0.1)",
        }}>
          © 2026 NewStyle23. Todos los derechos reservados.
        </p>
        <p style={{
          fontSize: "0.8rem",
          opacity: 0.4,
          margin: "0.8rem 0 0 0",
        }}>
          Desarrollado por{" "}
          <a
            href="https://topindev.cloud"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#fbbf24",
              textDecoration: "none",
              cursor: "pointer",
            }}
          >
            Topindev.cloud
          </a>
        </p>
      </motion.div>
    </div>
  );
}